const INACTIVE_STATUSES = ['inactive', 'suspended', 'archived'];

export function isInactiveCollaborator(
    status: string | null | undefined,
    endDate: string | null | undefined,
    today: string
): boolean {
    const normalized = (status ?? '').trim().toLowerCase();
    if (
        normalized.startsWith('inativ') ||
        normalized.startsWith('desligad') ||
        INACTIVE_STATUSES.includes(normalized)
    ) {
        return true;
    }
    return Boolean(endDate) && /^\d{4}-\d{2}-\d{2}$/.test(endDate as string) && (endDate as string) <= today;
}
